import React, { useEffect, useState } from 'react';
import { Table,Card,Spin,Menu,Modal,Select,Input} from 'antd';
import { EditOutlined, DownloadOutlined } from '@ant-design/icons';
import utils from 'cl-library/dist/utils/index'
import MoreTableData from './moreTableData';
import { CSVLink } from "react-csv";
// import EllipsisDropdown from 'cl-library/dist/components/shared-components/EllipsisDropdown/index';
import Flex from 'cl-library/dist/components/shared-components/Flex/index'
import config from "../../config.json";
import axios from 'axios';
const header=[
{label:"Date",key:"Date"},
{label:"Token_no",key:"token_no"},
{label:"Reason",key:"reason"},
{label:"Worksheet",key:"worksheet"},
];

const token = localStorage.getItem("token");
const TableData = ({data}) =>{
let date= new Date();
const today = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
const time=`${date.getHours()}:${date.getMinutes()}`
 
  let csvRport={
    filename:`"English sheet"+${today}+${time}`,
    headers:header,
    data:data
}
const [apiError, setapiError] = useState(null);
  
    const [loading, setLoading] = useState(true);  
    // // eslint-disable-next-line
    const [tableData,setTableData]=useState(data);
    // eslint-disable-next-line
    const [visible, setVisible]= useState(false);

    const [tokens, setToken] = useState("");


   
    
    const columns = [
          {
            title: "Date",
            dataIndex: "Date",
            key: "Date",
            fixed: "left",
            sorter: (a, b) => utils.antdTableSorter(a, b, 'Date')
          },
          
          {
            title: "Token No",
            dataIndex: "token_no",
            key: "token_no",
            fixed: "left",
            sorter: (a, b) => utils.antdTableSorter(a, b, 'token_no')
          },
          {
            title: "Reason",
            dataIndex: "reason",
            key: "reason",
            fixed: "left",
            sorter: (a, b) => utils.antdTableSorter(a, b, 'reason')
          },
          {
            title: "Worksheet No",
            dataIndex: "worksheet",
            key: "worksheet",
            fixed: "left",            
            sorter: (a, b) => utils.antdTableSorter(a, b, 'worksheet')
          },
    ];
 
    useEffect(()=>{
      async function fatchData(){
        data.map((obj,index)=>{obj.index=index})
        setTableData(data);
        setLoading(false)
      }
      fatchData();
      // eslint-disable-next-line 
    },[data])

    const dropdownMenu = elm => (
      <Menu>
        <Menu.Item>
          <Flex alignItems="center">     
            <span className="ml-2" onClick={() => showModal(elm)}><EditOutlined className='mr-1'/>Form</span>
          </Flex>
        </Menu.Item>
      </Menu>
    );

    const handleOk = () => {
      var label = document.getElementById("Label_no").value;
      var sheet = document.getElementById("Sheet_no").value;
      var Tokens = tokens;

      let data = {
        "Label_no" : label,
        "Sheet_no" : sheet,
        "token_no" : Tokens
      }
      let url = config.OMsubmitdata;
      axios.post(url, data, { headers: { 'Authorization': token } })
        .then(resp => {
          
            if (resp.data.status === "error") setapiError(resp.data);
              alert("Updated Successfully");
              window.location='/omCrPortal/app/home';
        }, err => {
            let obj={"status":"error","message":"Network Error"};
            if(err.response) setapiError(err.response);
            else setapiError(obj);
        });
    };
    const handleCancel = () => {
      setVisible(false);
    };

    const showModal = (elm) => {
      setVisible(true);
      alert(elm.token_no);
      setToken(elm.token_no);
    };
   
    return (
      loading ? (<Spin tip='loading'></Spin>) :
        <>      
            <Card title="Active Students" 
                  style={{ 'fontSize': '5px' }} 
                  extra={ 
                        <CSVLink {...csvRport}>
                         <DownloadOutlined style={{ 'fontSize': 30 }}/>
                        </CSVLink>
                      }> 
                  <Table xs={24} sm={50} md={50}
                      columns={columns} 
                      dataSource={tableData} 
                      rowKey='index'  
                      expandable={{ expandedRowRender:record=>{
                        return <MoreTableData record={record}/>;
                      } }} 
                    />
              </Card>
            
        </>
    )
}

export default TableData